module.exports = __webpack_public_path__ + "static/media/B1_ROUGH.18032c03.png";